import DriversReportTable from "./DriversReportTable";

export default function DriversReport() {
  return <DriversReportTable />;
}
